// Chamadas da reabertura de pedido concluído (backend api/v1/reabrir_pedido).
import axios from "axios";

const API = "/api";
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

/** Pode reabrir? Por que não? + mesa ocupada/livres + histórico. */
export const checarReabertura = (pedidoId) =>
  axios.get(`${API}/pedidos/${pedidoId}/reabertura`, auth()).then((r) => r.data);

export const reabrirPedido = (pedidoId, mesaDestino) =>
  axios.post(`${API}/pedidos/${pedidoId}/reabrir`, mesaDestino ? { mesa_destino: mesaDestino } : {}, auth()).then((r) => r.data);
